import { render, staticRenderFns } from "./BugEditModal.vue?vue&type=template&id=00c03bef&scoped=true&"
import script from "./BugEditModal.vue?vue&type=script&lang=js&"
export * from "./BugEditModal.vue?vue&type=script&lang=js&"
import style0 from "./BugEditModal.vue?vue&type=style&index=0&id=00c03bef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c03bef",
  null
  
)

export default component.exports